import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
// component
import AppRoutes from "AppRoutes";
import Toaster from "Components/UI/Toaster";
// redux
import { setLanguage } from "store/Actions/langaugeActionCreator";

// helper
import "Language/i18n";

// css

import "Assets/css/bootstrap.min.css";
import "Assets/css/style.css";
import "Assets/css/global-admin.css";
import { ThemeProvider } from "@mui/material";
import theme from "theme";
import { RootState } from "store";

function App() {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const language = useSelector(
    (state: RootState) => state?.dashboard?.language
  );

  useEffect(() => {
    if (language) {
      dispatch(setLanguage(language));
      i18n.changeLanguage(language);
    }
  }, [language]);

  return (
    <ThemeProvider theme={theme}>
      <div className="global-admin">
        <AppRoutes />
        <Toaster />
      </div>
    </ThemeProvider>
  );
}

export default App;
